import { appConfig } from '../../config';
import {
    jsonHeaderAuth,
    refreshAuthLogic
} from '../fetchTools';
import axios from 'axios';
import { saveAs } from 'file-saver';


export const getDaftarEq = async () => {
    const url = `${appConfig.BASE_API}/equipment/read/${localStorage.getItem('id')}`;
    const result = await axios.get(url, jsonHeaderAuth())
        .then(res => {
            // console.log('getDaftareq', res.data)
            return {status: res.status, data: res.data}
        })
        .catch(error => {
            // console.log('error', error)
            return null;
        })    
    return result

}

export const createDaftarEq = async (payload) => {

    try {
        const res = await axios.post(`${appConfig.BASE_API}/equipment/create`, payload, {
            headers: {
                ...jsonHeaderAuth()
            }
        })

        return {status: res.status, data: res.data}
    } catch (error) {
        return { status: error.code, message: error.message }
    }
}

export const deleteDaftarEq = async (id) => {

    try {
        const res = await axios.post(`${appConfig.BASE_API}/equipment/delete/${id}`, jsonHeaderAuth())

        return {status: res.status, data: res.data}
    } catch (error) {
        return { status: error.code, message: error.message }
    }
}

export const updateDaftarEq = async (id, payload) => {

    try {
        const res = await axios.post(`${appConfig.BASE_API}/equipment/update/${id}`, payload, {
            ...jsonHeaderAuth()
        })

        return {status: res.status, data: res.data}
    } catch (error) {
        return { status: error.code, message: error.message }
    }
}

export const getDownloadEquipment = async (id) => {
    try {
        await axios({url:`${appConfig.BASE_API}/equipment/download`,method:'get',responseType: 'blob'})
        .then(res => {
            console.log(res)
            const blob = new Blob([res.data], {
                type: 'application/octet-stream'
            })

            saveAs(blob, "equipments.xlsx")
        })
        .catch(error => {
            console.log(error.message);
        });
        
        return 0
    } catch (error) {
        return { status: error.code, message: error.message }
    }
}
export const UploadEquipment = async (file) => {
    try {
        var formData = new FormData()
        formData.append('file',file)
        let data=await axios.post(`${appConfig.BASE_API}/equipment/upload`,formData,
            {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
            })
        console.log(data)
        return data.data
        
    } catch (error) {
        console.log(error)
        return error
    }
}
